import { LitElement, html, css } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

import { nsFlyoutStyles, nsSharedStyles, nsLayoutStyles } from '../ns-styles/index.js';

@customElement(NSBackgroundTasks.is)
export class NSBackgroundTasks extends LitElement {
  static get is() {
    return 'ns-background-tasks';
  }

  @property({ type: Boolean, reflect: true })
  open = false;

  @query('.wrapper')
  private __wrapper?: HTMLElement;

  private __tasks?: {
    progress: number;
    name: string;
  }[];

  static styles = [
    nsLayoutStyles,
    nsSharedStyles,
    nsFlyoutStyles,
    css`
      :host {
        bottom: var(--ns-theme-viewport-padding, 40px);
        max-height: 300px;
        border-radius: var(--wa-border-radius-l);
        width: 100%;
        max-width: 300px;
        overflow: hidden;

        background: var(--wa-color-surface-raised);
        color: var(--wa-color-text-normal);
        display: block;
        height: 100%;

        overflow-y: auto;
      }

      .wrapper {
        padding: var(--wa-space-m);
      }

      .wrapper:focus {
        outline: 2px solid var(--wa-color-focus);
        outline-offset: -2px;
        border-radius: var(--wa-border-radius-l);
      }

      .no-tasks {
        font-weight: 700;
      }
    `,
  ];

  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;

    // Probably will be saving them in our database?
    this.__tasks = [];
  }

  focusPanel() {
    this.__wrapper?.focus();
  }

  render() {
    return html`
      <div class="wrapper layout vertical h-100" role="region" aria-label="Background tasks" tabindex="-1">
        ${this.__tasks && this.__tasks.length > 0
          ? repeat(
              this.__tasks,
              (task) => html`
                <div class="layout horizontal">
                  <div class="task-name">${task.name}</div>
                  <div class="task-progress">${task.progress}</div>
                </div>
              `,
            )
          : html`
              <div class="layout vertical center-center h-100 no-tasks">There are no background task at the moment</div>
            `}
      </div>
    `;
  }
}
